/* LKT correctifs globaux : prix WideBundle au format €14,10, libellés d'offre exacts, panier en français, « Ajouter » sur mobile, sans badges Nouveau */
(function () {
  var EUR = /€\s?(\d+)\.(\d{2})(?!\d)/g;
  function m(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function cnt(t) {
    t = String(t || '');
    var x = t.match(/(\d+)\s*bougies?/i);
    if (x) return Number(x[1]);
    if (/duo/i.test(t)) return 2;
    if (/trio/i.test(t)) return 3;
    return 1;
  }
  function fixText(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (v.indexOf('€') > -1 && /\.\d{2}/.test(v)) { var r = v.replace(EUR, '€$1,$2'); if (r !== v) n.nodeValue = r; }
    }
  }
  var prod = null;
  if (/\/products\//.test(location.pathname)) {
    fetch(location.pathname.replace(/\/$/, '') + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { prod = p; run(); }).catch(function () {});
  }
  function fixWB() {
    var opts = document.querySelectorAll('.new-form-option[data-variant-id]');
    if (!opts.length) return;
    Array.prototype.forEach.call(document.querySelectorAll('.first-price-WB, .second-price-WB, .price-new-form, [class*="WB"] .money'), fixText);
    if (!prod || !prod.variants) return;
    var unit = null;
    prod.variants.forEach(function (v) { if (!unit && cnt(v.title) === 1) unit = v; });
    Array.prototype.forEach.call(opts, function (o) {
      var v = null;
      prod.variants.forEach(function (x) { if (String(x.id) === o.getAttribute('data-variant-id')) v = x; });
      if (!v) return;
      var t = o.querySelector('.title-variant');
      var n = cnt(t ? t.textContent : v.title);
      var bt = o.querySelector('.best-title');
      if (!bt || n < 2) return;
      var ref = unit ? unit.price * n : (v.compare_at_price || 0);
      var pct = ref > v.price ? Math.round((1 - v.price / ref) * 100) : 0;
      var txt = n + ' bougies' + (pct >= 3 ? ' : -' + pct + ' %' : '') + ' · ' + m(Math.round(v.price / n)) + ' / bougie ' + (n >= 3 ? '🎁' : '🔥');
      if (bt.textContent !== txt) bt.textContent = txt;
    });
  }
  function fixCart() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-option dt, .cart-item__details dt'), function (dt) {
      if (/^\s*Offer\s*:?\s*$/i.test(dt.textContent)) dt.textContent = 'Format :';
    });
    Array.prototype.forEach.call(document.querySelectorAll('[aria-label*="&amp;"]'), function (e) { e.setAttribute('aria-label', e.getAttribute('aria-label').replace(/&amp;/g, '&')); });
    Array.prototype.forEach.call(document.querySelectorAll('.quantity__button .visually-hidden, .cart-item .visually-hidden'), function (e) {
      if (e.textContent.indexOf('&amp;') > -1) e.textContent = e.textContent.replace(/&amp;/g, '&');
    });
  }
  var MOB = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
  function fixMobileAtc() {
    if (!MOB.matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('button, .button, a.dz-qa, [class*="WB"] [type="submit"]'), function (b) {
      var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) { if (/Ajouter au panier/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/Ajouter au panier/i, 'Ajouter'); }
    });
  }
  function hideNewBadges() {
    Array.prototype.forEach.call(document.querySelectorAll('[class*="badge"], [class*="pill"], [class*="__new"], [class*="tag"], .dz-stage__meta small'), function (e) {
      if (e.closest('.ds-kicker, nav, header, footer, .lkt-ch__nav, .ds-lp-sticky') || e.children.length > 1) return;
      if (/^\s*(nouveaut[ée]s?|nouveau|new)\s*!?\s*$/i.test(e.textContent) && e.style.display !== 'none') e.style.display = 'none';
    });
  }
  var busy = false, timer = null;
  function run() { if (busy) return; busy = true; try { fixWB(); fixCart(); fixMobileAtc(); hideNewBadges(); } catch (e) {} busy = false; }
  function later() { clearTimeout(timer); timer = setTimeout(run, 120); }
  function init() {
    run();
    if (window.MutationObserver) new MutationObserver(function () { if (!busy) later(); }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
